import { render, staticRenderFns } from "./NextSwitch.vue?vue&type=template&id=32db3102&scoped=true"
import script from "./NextSwitch.vue?vue&type=script&lang=js"
export * from "./NextSwitch.vue?vue&type=script&lang=js"
import style0 from "./NextSwitch.vue?vue&type=style&index=0&id=32db3102&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32db3102",
  null
  
)

export default component.exports